import React from 'react';
import { PageHeader } from './PageHeader';

export const About = props => {
    return (
        <React.Fragment>
        <PageHeader title="O zjeździe"/>
        <div className="content-wrapper">
            <div className="main-content about">
                <h2> 45 Zjazd Fizyków Polskich, organizowany przez Oddział Krakowski PTF, odbędzie się w dniach 13-18 września 2019 roku. </h2>
                <p>
                    45. Zjazd Fizyków Polskich odbędzie się w Krakowie w dniach 13-18 września 2019 roku.
                    Zjazd ten będzie kontynuacją spotkań fizyków polskich zapoczątkowanych Zjazdem
                    Założycielskim Polskiego Towarzystwa Fizycznego w 1920 roku w Warszawie, a
                    kontynuowanych w ostatnich latach przez kongresy w Lublinie (2011), Poznaniu (2013),
                    Kielcach (2015) i Wrocławiu (2017). 45. Zjazd Fizyków Polskich będzie miał również
                    szczególny charakter ze względu na inaugurację obchodów 100-lecia Polskiego Towarzystwa
                    Fizycznego oraz obchody 100-lecia obecności fizyki w Akademii
                    Górniczo-Hutniczej.
                </p>
                <p>
                    Jak poprzednie kongresy Zjazd w Krakowie będzie okazją spotkania naukowców z różnych
                    gałęzi fizyki i dziedzin pokrewnych, nauczycieli fizyki, przedstawicieli przemysłu i instytucji
                    finansujących badania naukowe i ich wdrożenia, studentów, uczniów i amatorów -
                    pasjonatów fizyki. Sesje konferencyjne pokryją szeroką tematykę badawczą. Miedzy innymi
                    planowane są sesje poświęcone:
                </p>
                    <ul>
                        <li>Fizyce jądrowej</li>
                        <li>Fizyce cząstek</li>
                        <li>Fizyce materii skondensowanej</li>
                        <li>Fizyce medycznej i biofizyce</li>
                        <li>Fizyce statystycznej</li>
                        <li>Fizyce układów złożonych</li>
                        <li>Grawitacji, kosmologii i astrofizyce</li>
                        <li>Nanofizyce i nanotechnologii</li>
                        <li>Fizyce atomowej, molekularnej, optycznej i fotonice oraz informacji kwantowej</li>
                        <li>Fizyce środowiska</li>
                        <li>Metodom matematyki i informatyki w fizyce</li>
                    </ul>
                <p>
                    Osobne sesje poświęcone będą dydaktyce fizyki na różnych poziomach kształcenia.
                    Integralną częścią Zjazdu będzie Konferencja Dydaktyczna dla nauczycieli fizyki. Odbędzie
                    się ona 14 i 15 września 2019 i będzie łączyła sesje równoległe, warsztaty dydaktyczne i
                    pokazy eksperymentów fizycznych.
                    45. Zjazd Fizyków Polskich będzie również miejscem spotkania ludzi biznesu z naukowcami.
                    Pragniemy aby Zjazd był miejscem wymiany poglądów i zawierania współpracy, zarówno na
                    poziomie interpersonalnym jak i instytucjonalnym, t.j. pomiędzy naukowcami mającymi
                    potencjał badawczy i/lub gotowe pomysły mogące znaleźć zastosowanie w przemyśle,
                    przedstawicielami przedsiębiorców, szczególnie małych start-upów oraz przedstawicieli
                    instytucji finansujących prace wdrożeniowe. Planujemy rozpowszechnianie idei doktoratów
                    wdrożeniowych oraz prezentację działalności przyuczelnianych centrów rozwoju technologii
                    zrzeszonych w ogólnopolskiej sieci Porozumienie Akademickich Centrów Transferów
                    Technologii (PACTT). Specjalna dwudniowa sesja „Fizyka – Przemysł – Innowacje”
                    planowana jest na 16 i 17 września 2019.
                    Łącznie planowanych jest około 30 wykładów plenarnych oraz blisko 200 wykładów w
                    równoległych sesjach tematycznych. Wśród prelegentów znajdą się wybitni polscy naukowcy
                    i goście zagraniczni, a niektórzy z nich będą panelistami w debacie „Przyszłość fizyki”.
                    Zjazdowi towarzyszyć też będzie sesja plakatowa.
                </p>
                <p>
                    Tradycyjnie, w czasie Zjazdu zostaną wręczone nagrody Polskiego Towarzystwa Fizycznego:
                    medalu Mariana Smoluchowskiego, nagród naukowych PTF, nagrody PTF za Popularyzację
                    Fizyki oraz nagrody PTF dla Nauczycieli Fizyki. Z okazji zbliżającego się 100-lecia
                    Polskiego Towarzystwa Fizycznego wręczone zostaną pierwsze Medale Stulecia Polskiego
                    Towarzystwa Fizycznego za działalność społeczną na rzecz środowiska i Towarzystwa. W
                    trakcie Zjazdu odbędzie się również Walne Zebranie Delegatów Polskiego Towarzystwa
                    Fizycznego.
                    Zjazdowi towarzyszyć też będą różnorodne wydarzenia a charakterze popularyzatorskim i
                    kulturalnym. Będzie również okazją do zwiedzenia wybranych krakowskich laboratoriów
                    badawczych i samego Krakowa.
                </p>

            </div>
        </div>
        </React.Fragment>
    );
};

About.propTypes = {
    
};
